import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import Button from '@mui/material/Button';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { selectUser } from 'app/store/userSlice';
import { Alert, IconButton, Snackbar } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CreateTdmStepper from '../components/CreateTdmStepper';
import { getTdmFileById, selectTransitRowSliceData, setTdmJsonDefault } from '../../store/TransitSlice';
import AddIcon from '@mui/icons-material/Add';

function TdmDetailPageHeader() {
    const [showDialog, setShowDialog] = useState(false);
    const [fileData, setFileData] = useState({});
    const [snackMesaage, setSnackMesaage] = useState(null);
    const [snackVarient, setSnackVarient] = useState(null);
    const [snackOpen, setSnackOpen] = useState(false);

    const userData = useSelector(selectUser)
    const rowData = useSelector(selectTransitRowSliceData)
    const dispatch = useDispatch()


    const navigate = useNavigate()
    const params = useParams()

    const handleGoBack = () => {
        navigate('/apps/transitDataManager/demoTDM')
    };

    const handleClickOpen = (row) => {
        setShowDialog(true);
    };


    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackOpen(false);
    };

    useEffect(() => {
        if (!rowData || Object.keys(rowData)?.length <= 0 || rowData?.id !== params?.id) {
            let body = {
                id: params?.id,
            }
            dispatch(getTdmFileById(body)).then((res) => {
                if (res?.payload?.response && res?.payload?.response.status != 200) {
                    handleGoBack()
                } else {
                    setFileData(res?.payload?.data || {})
                }
            }).catch((err) => {
                handleGoBack()
            })
        } else {
            setFileData(rowData || {})
        }
    }, [params?.id])

    return (
        <>
            <div className="flex flex-col items-center justify-between w-full p-24 space-y-8 sm:p-32 sm:flex-row sm:space-y-0">
                <div className="flex flex-col items-center space-y-8 sm:items-start sm:space-y-0">
                    <motion.span
                        className="flex items-end"
                        initial={{ x: -20 }}
                        animate={{ x: 0, transition: { delay: 0.2 } }}
                        delay={300}
                    >
                        <div className="flex flex-row items-center space-x-16">
                            <IconButton onClick={handleGoBack} aria-label="go back">
                                <ArrowBackIcon />
                            </IconButton>
                            <Typography
                                // component={Link}
                                // to="/apps/transitDataManager/demoTDM"
                                className="font-extrabold leading-none tracking-tight text-20 md:text-32"
                            // role="button"
                            >
                                {fileData?.agency_key}
                            </Typography>
                        </div>
                    </motion.span>
                </div>

                <div className="flex items-center -mx-8"
                    onClick={(() => {
                        if ((userData?.role === "admin-restricted" || userData?.role === "provider-restricted") && !userData?.data?.userRestrictions?.rights?.tdmMobilityActions) {
                            setSnackVarient("warning");
                            setSnackMesaage("You donot have permission");
                            setSnackOpen(true);
                        }
                    })}
                >
                    <Button
                        className="mx-8 whitespace-nowrap"
                        variant="contained"
                        color="secondary"
                        onClick={handleClickOpen}
                        disabled={
                            (userData?.role === "admin-restricted" || userData?.role === "provider-restricted") &&
                            !userData?.data?.userRestrictions?.rights?.tdmMobilityActions
                        }
                    >
                        <AddIcon />
                        Json
                    </Button>
                </div>
            </div>

            <Snackbar
                open={snackOpen}
                autoHideDuration={2000}
                onClose={handleCloseSnack}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Alert onClose={handleCloseSnack} variant="filled" severity={snackVarient} >
                    {snackMesaage}
                </Alert>
            </Snackbar>
            {showDialog && <CreateTdmStepper showDialog={showDialog} setShowDialog={setShowDialog} rowData={fileData} dialogType="create" />}
        </>

    );
}

export default TdmDetailPageHeader;
